const isEmptyString = (v: unknown): v is string => typeof v === 'string' && v.trim().length === 0;

const isNonEmptyString = (v: unknown): v is string => typeof v === 'string' && !isEmptyString(v);

export const hasAnyImage = (imageArray: string[]): boolean => imageArray.some(isNonEmptyString);
